import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

export function useApi<T>(key: string[], url: string, enabled = true) {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      const res = await api.get<{ success: boolean; data: T }>(url);
      return res.data as T;
    },
    enabled,
  });
}

export function useList<T>(key: string[], url: string) {
  return useQuery({
    queryKey: key,
    queryFn: async () => {
      const res = await api.get<{ success: boolean; data: T[] }>(url);
      return (res.data ?? []) as T[];
    },
  });
}
